import Vue from 'vue';
// This variable will hold the reference to
// document's click handler
let handleOutsideClick: (this: Document, ev: Event) => void;

export const OutsideClick: import('vue').DirectiveOptions = {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const { handler, exclude = [], } = binding.value as { handler: string, exclude: string[], };
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach((refName) => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					// Get the element using the reference name
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
					let excludedEl = vnode.context?.$refs[refName] as any;
					// Get the actual element if it is a Vue component
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
					excludedEl = (excludedEl instanceof Vue) ? excludedEl.$el : excludedEl;
					if (excludedEl) {
						// See if this excluded element
						// is the same element the user just clicked on
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});

			// We check to see if the clicked element is not
			// the dialog element and not excluded
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			if (!el.contains(e.target as any) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
				(vnode.context as any)[handler]();
			}
		};
		// Register click/touchstart event listeners on the whole page
		document.addEventListener('click', handleOutsideClick);
		document.addEventListener('touchstart', handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener('click', handleOutsideClick);
		document.removeEventListener('touchstart', handleOutsideClick);
	},
};
